<dashboard-loader *ngIf="(isReleasesReady$ | async) === false" [title]="'Loading Release Notes...'"></dashboard-loader>
<div *ngFor="let releaseNote of releaseNotes$ | async" class="dashboard-release-notes-list">
  <mat-card
    class="dashboard-release-notes-list__card"
    [ngClass]="(isSideNavOpen$ | async) ? 'dashboard-release-note-list__card--sidenav' : ''"
  >
    <mat-card-title>{{ releaseNote?.title }}</mat-card-title>
    <mat-card-subtitle>{{ releaseNote?.createdAt }}</mat-card-subtitle>
    <mat-card-content class="dashboard-release-notes-list__card-description">{{
      releaseNote?.description
    }}</mat-card-content>
    <mat-card-footer class="dashboard-release-notes-list__card-tags">
      <section
        [ngClass]="{
          'dashboard-release-notes-list__card-tags--sidebar': (isSideNavOpen$ | async)
        }"
      >
        Tags:
        <ul class="dashboard-release-notes-list__card-tags-list">
          <li *ngIf="releaseNote.updates">Updates</li>
          <li *ngIf="releaseNote.regular">Regular</li>
          <li *ngIf="releaseNote.careercompass">Careercompass</li>
        </ul>
      </section>
      <ng-container *ngIf="isSideNavOpen$ | async as isSideNavOpen">
        <mat-divider></mat-divider>
        <mat-card-actions fxLayoutAlign="end" class="dashboard-release-notes-list__card-tags-actions">
          <button mat-button (click)="openEditReleaseNoteDialog(releaseNote)">
            {{ 'edit' | uppercase }}
          </button>
          <button mat-button color="warn" (click)="openDeleteReleaseNoteDialog(releaseNote)">
            {{ 'delete' | uppercase }}
          </button>
        </mat-card-actions>
      </ng-container>
    </mat-card-footer>
  </mat-card>
</div>

<ng-template class="dashboard-release-notes-list__delete-dialog" #deleteDialog>
  <div class="dashboard-release-notes-list__delete-dialog-title" mat-dialog-title>
    Are you sure you want to delete this release note?
  </div>
  <mat-dialog-actions fxLayoutAlign="end">
    <button mat-button class="dashboard-release-notes-list__delete-dialog-action-button" mat-dialog-close>
      {{ 'cancel' | uppercase }}
    </button>
    <button
      mat-button
      class="dashboard-release-notes-list__delete-dialog-action-button"
      color="warn"
      (click)="deleteReleaseNote()"
    >
      {{ 'delete' | uppercase }}
    </button>
  </mat-dialog-actions>
</ng-template>
